const contentMediaTypeCheck = {
  severity: "ERROR",
  type: "CONTENT",
  fieldName: "asset",
  errorMessage: "Unsupported file format for selected content type",
  resolutionMessage: "Please upload file with supported file format",
};

export default contentMediaTypeCheck;
